// The hold on an SSO-only tenant's automatic SSO start.
//
// The tenant's login page sends the browser straight to the SSO start for its
// one connection, so a click on the identity provider's tile signs the user in
// with no input. Left unchecked, that start would also run after a log out
// (signing the user straight back in through their identity-provider session)
// and after a return that failed (starting the flow again, forever). So it
// runs once per tab: the page holds it as it starts, a log out holds it, and
// it is released only once a signed-in user has loaded. While it is held the
// page shows its "Continue with SSO" button instead.
//
// Per tab (`sessionStorage`) on purpose: every tile click opens a new tab,
// which starts on its own again. Storage can be unavailable (a locked-down
// profile); the start then reads as held, so the page shows its button: a
// hold that cannot be recorded must never become a loop.

const HELD_KEY = "fp_sso_autostart_held";

export const ssoAutoStartHeld = (): boolean => {
  try {
    return sessionStorage.getItem(HELD_KEY) === "1";
  } catch {
    return true;
  }
};

export const holdSsoAutoStart = (): void => {
  try {
    sessionStorage.setItem(HELD_KEY, "1");
  } catch {
    // Storage unavailable: see the module comment.
  }
};

export const releaseSsoAutoStart = (): void => {
  try {
    sessionStorage.removeItem(HELD_KEY);
  } catch {
    // Storage unavailable: see the module comment.
  }
};
